"use client";
import { jsx } from "react/jsx-runtime";
import { iconRegistry } from "@pcln/horizon-icons";
import { memo, useEffect, useRef } from "react";
import { cn } from "../../utils/index.js";
import { cdnIconVariants } from "../CdnIcon/CdnIcon.variants.js";
const HorizonIcon = /*#__PURE__*/ memo(({ name, className, palette, shade, size, ...svgProps })=>{
    const { role: roleProp, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-hidden': ariaHiddenProp, ...restSvgProps } = svgProps;
    const hasAccessibleName = Boolean(ariaLabel || ariaLabelledBy);
    const shouldHaveRole = ('img' === roleProp || void 0 === roleProp) && hasAccessibleName;
    const finalAriaHidden = shouldHaveRole ? ariaHiddenProp : ariaHiddenProp ?? true;
    const containerRef = useRef(null);
    useEffect(()=>{
        if (!shouldHaveRole && containerRef.current) {
            const svgElement = containerRef.current.querySelector('svg');
            if (svgElement?.getAttribute('role') === 'img') svgElement.removeAttribute('role');
        }
    }, [
        shouldHaveRole
    ]);
    if (!name) return null;
    const IconComponent = iconRegistry[name];
    if (!IconComponent) throw new Error(`@pcln/horizon-icons//HorizonIcon: Icon ${name} not found`);
    const finalSvgProps = {
        ...restSvgProps,
        'aria-hidden': finalAriaHidden
    };
    if (ariaLabel) finalSvgProps['aria-label'] = ariaLabel;
    if (ariaLabelledBy) finalSvgProps['aria-labelledby'] = ariaLabelledBy;
    if (shouldHaveRole) finalSvgProps.role = 'img';
    const classes = cn(cdnIconVariants({
        palette,
        shade,
        size
    }), className);
    const paletteStyle = palette ? {
        '--horizon-icon-shade-1': `var(--color-${palette}-1)`,
        '--horizon-icon-shade-4': `var(--color-${palette}-4)`
    } : void 0;
    return /*#__PURE__*/ jsx("div", {
        ref: containerRef,
        className: classes,
        style: paletteStyle,
        children: /*#__PURE__*/ jsx(IconComponent, {
            ...finalSvgProps
        })
    });
});
export { HorizonIcon };
